export const DOWNLOAD_QSG = 'vtn-component-user-onboarding/DOWNLOAD_QSG';

export const actionDownloadQSG = () => ({
  type: DOWNLOAD_QSG,
});
